import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createTextVNode as _createTextVNode, createCommentVNode as _createCommentVNode, createVNode as _createVNode, vModelText as _vModelText, withDirectives as _withDirectives, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = { class: "flex gap-6 items-start" }
const _hoisted_2 = { class: "w-56 flex-shrink-0 sticky top-0" }
const _hoisted_3 = { class: "bg-white rounded-xl border border-gray-200 shadow-sm p-3" }
const _hoisted_4 = { class: "space-y-0.5" }
const _hoisted_5 = ["onClick"]
const _hoisted_6 = { class: "space-y-0.5" }
const _hoisted_7 = { class: "flex-1 min-w-0 space-y-6" }
const _hoisted_8 = {
  key: 0,
  class: "bg-white rounded-xl border border-gray-200 shadow-sm p-6 space-y-4"
}
const _hoisted_9 = { class: "bg-gray-900 text-gray-100 rounded-lg p-4 text-xs overflow-x-auto" }
const _hoisted_10 = {
  key: 1,
  class: "bg-white rounded-xl border border-gray-200 shadow-sm p-6 space-y-4"
}
const _hoisted_11 = { class: "border border-gray-200 rounded-lg divide-y divide-gray-200" }
const _hoisted_12 = { class: "text-sm text-[#8C0004] font-medium" }
const _hoisted_13 = { class: "text-xs text-gray-600 mt-0.5" }
const _hoisted_14 = {
  key: 2,
  class: "bg-white rounded-xl border border-gray-200 shadow-sm p-6 space-y-4"
}
const _hoisted_15 = { class: "border border-gray-200 rounded-lg divide-y divide-gray-200 mt-3" }
const _hoisted_16 = { class: "text-sm text-[#8C0004] font-medium" }
const _hoisted_17 = { class: "text-xs text-gray-600 mt-0.5" }
const _hoisted_18 = { class: "bg-white rounded-xl border border-gray-200 shadow-sm p-6" }
const _hoisted_19 = { class: "flex items-center gap-3 mb-3" }
const _hoisted_20 = { class: "text-sm font-mono text-gray-900" }
const _hoisted_21 = {
  key: 0,
  class: "px-2 py-0.5 rounded-full bg-gray-100 text-gray-600 text-xs font-medium"
}
const _hoisted_22 = { class: "text-lg font-bold text-gray-900 mb-1" }
const _hoisted_23 = { class: "text-sm text-gray-600" }
const _hoisted_24 = { class: "text-sm font-semibold text-gray-900 mb-2" }
const _hoisted_25 = { class: "border border-gray-200 rounded-lg divide-y divide-gray-200" }
const _hoisted_26 = { class: "flex items-baseline gap-2 flex-wrap" }
const _hoisted_27 = { class: "text-xs font-semibold text-gray-900" }
const _hoisted_28 = { class: "text-[11px] text-gray-500 font-mono" }
const _hoisted_29 = {
  key: 0,
  class: "text-[11px] text-gray-500"
}
const _hoisted_30 = { class: "text-gray-700" }
const _hoisted_31 = { class: "text-xs text-gray-600 mt-1" }
const _hoisted_32 = {
  key: 0,
  class: "mt-2 space-y-1 pl-3 border-l-2 border-gray-100"
}
const _hoisted_33 = { class: "text-[11px] font-semibold text-[#8C0004] flex-shrink-0" }
const _hoisted_34 = { class: "text-[11px] text-gray-600" }
const _hoisted_35 = { class: "bg-white rounded-xl border border-gray-200 shadow-sm p-6" }
const _hoisted_36 = { class: "border border-gray-200 rounded-lg divide-y divide-gray-200 overflow-hidden" }
const _hoisted_37 = ["onClick"]
const _hoisted_38 = { class: "text-sm font-medium text-gray-900 flex-shrink-0" }
const _hoisted_39 = {
  key: 0,
  class: "text-[11px] text-gray-500"
}
const _hoisted_40 = {
  key: 0,
  class: "px-3 pb-3"
}
const _hoisted_41 = { class: "text-xs text-gray-600 mb-2" }
const _hoisted_42 = { class: "bg-gray-900 text-gray-100 rounded-lg p-3 text-xs overflow-x-auto" }
const _hoisted_43 = { class: "bg-white rounded-xl border border-gray-200 shadow-sm p-6" }
const _hoisted_44 = { class: "flex items-center justify-between mb-4" }
const _hoisted_45 = { class: "text-xs text-gray-500" }
const _hoisted_46 = { class: "bg-gray-100 px-1 py-0.5 rounded" }
const _hoisted_47 = {
  key: 0,
  class: "px-3 py-1 rounded-full bg-red-100 text-red-800 text-xs font-semibold"
}
const _hoisted_48 = { class: "space-y-4" }
const _hoisted_49 = ["placeholder"]
const _hoisted_50 = { class: "text-xs text-gray-500 mt-1.5" }
const _hoisted_51 = { class: "block text-sm font-medium text-gray-700 mb-2" }
const _hoisted_52 = ["onUpdate:modelValue"]
const _hoisted_53 = { class: "text-xs text-gray-500 mt-1" }
const _hoisted_54 = { key: 0 }
const _hoisted_55 = ["disabled"]
const _hoisted_56 = {
  key: 0,
  class: "mt-6"
}
const _hoisted_57 = { class: "flex items-center gap-2 mb-2" }
const _hoisted_58 = { class: "bg-gray-900 text-gray-100 rounded-lg p-4 text-xs overflow-x-auto max-h-96" }
const _hoisted_59 = {
  key: 1,
  class: "mt-6"
}
const _hoisted_60 = { class: "text-sm font-medium text-gray-700 mb-2" }
const _hoisted_61 = { class: "bg-gray-50 border border-gray-200 text-gray-700 rounded-lg p-4 text-xs overflow-x-auto" }
const _hoisted_62 = { class: "bg-white rounded-xl border border-gray-200 shadow-sm p-6" }
const _hoisted_63 = { class: "bg-gray-900 text-gray-100 rounded-lg p-4 text-xs overflow-x-auto" }

import { ref, computed, watch } from 'vue'
import { Icon } from '@iconify/vue'
import { apiBaseUrlFor, LIVE_API_URL, TEST_API_URL } from '../services/api'
import { useModeStore } from '../store/mode'
import { API_ENDPOINTS, SANDBOX_SCENARIOS, ApiEndpoint, FieldSpec } from '../services/apiSpec'
import { EVENT_TYPES, EVENT_DESCRIPTIONS } from '../services/events'


export default /*@__PURE__*/_defineComponent({
  __name: 'DocsView',
  setup(__props) {

const modeStore = useModeStore()

const LIVE_BASE = LIVE_API_URL + '/v1'
const TEST_BASE = TEST_API_URL + '/v1'

const tab = ref<'endpoint' | 'auth' | 'webhooks' | 'sandbox'>('endpoint')
const selected = ref<ApiEndpoint>(API_ENDPOINTS[0])
const apiKey = ref(sessionStorage.getItem('partnerConsoleKey') || '')
const body = ref(API_ENDPOINTS[0].sampleBody || '')
const pathValues = ref<Record<string, string>>({})
const sending = ref(false)
const response = ref<{ ok: boolean; status: number; body: string } | null>(null)

const baseUrl = computed(() => apiBaseUrlFor(modeStore.mode))

// Réponses dépliables : les erreurs restent repliées, le cas nominal ouvert
const openResponses = ref<Record<number, boolean>>({ 0: true })

function toggleResponse(index: number) {
  openResponses.value = { ...openResponses.value, [index]: !openResponses.value[index] }
}

const successResponse = computed(() =>
  selected.value.responses.find((r) => r.status < 300)
)

const fieldGroups = computed(() => {
  const groups: { title: string; fields: FieldSpec[] }[] = []
  if (selected.value.pathParams?.length) {
    groups.push({ title: 'Paramètres de chemin', fields: selected.value.pathParams })
  }
  if (selected.value.queryParams?.length) {
    groups.push({ title: 'Paramètres de requête', fields: selected.value.queryParams })
  }
  if (selected.value.bodyFields?.length) {
    groups.push({ title: 'Corps de la requête', fields: selected.value.bodyFields })
  }
  return groups
})

function statusClass(status: number): string {
  if (status < 300) return 'bg-emerald-100 text-emerald-800'
  if (status < 500) return 'bg-amber-100 text-amber-800'
  return 'bg-red-100 text-red-800'
}

// La clé n'est jamais persistée durablement : sessionStorage seulement.
watch(apiKey, (v) => sessionStorage.setItem('partnerConsoleKey', v))

// Changer d'environnement invalide la clé saisie (une clé test ne vaut pas en live)
watch(
  () => modeStore.mode,
  () => {
    apiKey.value = ''
    response.value = null
  }
)

const resolvedPath = computed(() => {
  let path = selected.value.path
  for (const [name, value] of Object.entries(pathValues.value)) {
    path = path.replace(`:${name}`, value || `:${name}`)
  }
  return path
})

const curlSnippet = computed(() => {
  const lines = [`curl -X ${selected.value.method} ${baseUrl.value}${resolvedPath.value} \\`]
  lines.push(`  -H "Authorization: Bearer ${apiKey.value || 'VOTRE_CLE'}" \\`)
  if (selected.value.sampleBody) {
    lines.push(`  -H "Content-Type: application/json" \\`)
    if (selected.value.idempotent) {
      lines.push(`  -H "Idempotency-Key: $(uuidgen)" \\`)
    }
    lines.push(`  -d '${(body.value || '').replace(/\n\s*/g, ' ')}'`)
  } else {
    lines[lines.length - 1] = lines[lines.length - 1].replace(/ \\$/, '')
  }
  return lines.join('\n')
})

function select(ep: ApiEndpoint) {
  tab.value = 'endpoint'
  selected.value = ep
  body.value = ep.sampleBody || ''
  pathValues.value = {}
  response.value = null
  // Repartir avec le seul cas nominal déplié
  openResponses.value = { 0: true }
}

async function send() {
  sending.value = true
  response.value = null

  try {
    const headers: Record<string, string> = {
      Authorization: `Bearer ${apiKey.value}`,
    }
    const init: RequestInit = { method: selected.value.method, headers }

    if (selected.value.method === 'POST') {
      headers['Content-Type'] = 'application/json'
      if (selected.value.idempotent) {
        // Une clé neuve à chaque essai : la console sert à explorer, pas à rejouer
        headers['Idempotency-Key'] = `console-${Date.now()}-${Math.random().toString(36).slice(2, 8)}`
      }
      if (selected.value.sampleBody) {
        init.body = body.value
      }
    }

    const res = await fetch(`${baseUrl.value}${resolvedPath.value}`, init)
    const text = await res.text()

    let pretty = text
    try {
      pretty = JSON.stringify(JSON.parse(text), null, 2)
    } catch {
      /* réponse non-JSON : afficher telle quelle */
    }

    response.value = { ok: res.ok, status: res.status, body: pretty }
  } catch (err: any) {
    response.value = {
      ok: false,
      status: 0,
      body: `Requête impossible : ${err.message}\n\nVérifiez votre connexion.`,
    }
  } finally {
    sending.value = false
  }
}

return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("nav", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _cache[5] || (_cache[5] = _createElementVNode("p", { class: "text-xs font-semibold text-gray-400 uppercase tracking-wider px-3 py-2" }, " Endpoints ", -1)),
        _createElementVNode("ul", _hoisted_4, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(API_ENDPOINTS), (ep) => {
            return (_openBlock(), _createElementBlock("li", {
              key: ep.id
            }, [
              _createElementVNode("button", {
                onClick: ($event: any) => (select(ep)),
                class: _normalizeClass([
                'w-full text-left px-3 py-2 rounded-lg text-sm transition-colors',
                selected.value.id === ep.id
                  ? 'bg-[#8C0004] bg-opacity-10 text-[#8C0004] font-semibold'
                  : 'text-gray-700 hover:bg-gray-50'
              ])
              }, _toDisplayString(ep.title), 11, _hoisted_5)
            ]))
          }), 128))
        ]),
        _cache[6] || (_cache[6] = _createElementVNode("p", { class: "text-xs font-semibold text-gray-400 uppercase tracking-wider px-3 py-2 mt-3 border-t border-gray-100 pt-4" }, " Guides ", -1)),
        _createElementVNode("ul", _hoisted_6, [
          _createElementVNode("li", null, [
            _createElementVNode("button", {
              onClick: _cache[0] || (_cache[0] = ($event: any) => (tab.value = 'auth')),
              class: _normalizeClass(['w-full text-left px-3 py-2 rounded-lg text-sm', tab.value === 'auth' ? 'bg-gray-100 font-semibold' : 'text-gray-700 hover:bg-gray-50'])
            }, " Authentification ", 2)
          ]),
          _createElementVNode("li", null, [
            _createElementVNode("button", {
              onClick: _cache[1] || (_cache[1] = ($event: any) => (tab.value = 'webhooks')),
              class: _normalizeClass(['w-full text-left px-3 py-2 rounded-lg text-sm', tab.value === 'webhooks' ? 'bg-gray-100 font-semibold' : 'text-gray-700 hover:bg-gray-50'])
            }, " Webhooks & signature ", 2)
          ]),
          _createElementVNode("li", null, [
            _createElementVNode("button", {
              onClick: _cache[2] || (_cache[2] = ($event: any) => (tab.value = 'sandbox')),
              class: _normalizeClass(['w-full text-left px-3 py-2 rounded-lg text-sm', tab.value === 'sandbox' ? 'bg-gray-100 font-semibold' : 'text-gray-700 hover:bg-gray-50'])
            }, " Bac à sable ", 2)
          ])
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_7, [
      (tab.value === 'auth')
        ? (_openBlock(), _createElementBlock("section", _hoisted_8, [
            _cache[9] || (_cache[9] = _createStaticVNode("<h3 class=\"text-lg font-bold text-gray-900\">Authentification</h3><p class=\"text-sm text-gray-600\"> Chaque requête porte votre clé API dans l&#39;en-tête <code class=\"bg-gray-100 px-1.5 py-0.5 rounded text-xs\">Authorization</code>. Une clé <code class=\"bg-gray-100 px-1.5 py-0.5 rounded text-xs\">yk_test_</code> ne fonctionne que sur l&#39;URL sandbox, une clé <code class=\"bg-gray-100 px-1.5 py-0.5 rounded text-xs\">yk_live_</code> que sur l&#39;URL de production. </p>", 2)),
            _createElementVNode("pre", _hoisted_9, "curl " + _toDisplayString(baseUrl.value) + "/me \\\n  -H \"Authorization: Bearer VOTRE_CLE\"", 1),
            _createElementVNode("div", { class: "grid sm:grid-cols-2 gap-4 text-sm" }, [
              _createElementVNode("div", { class: "bg-amber-50 border border-amber-200 rounded-lg p-4" }, [
                _cache[7] || (_cache[7] = _createElementVNode("p", { class: "font-semibold text-amber-900 mb-1" }, "Sandbox (test)", -1)),
                _createElementVNode("code", { class: "text-xs break-all text-amber-800" }, _toDisplayString(TEST_BASE))
              ]),
              _createElementVNode("div", { class: "bg-emerald-50 border border-emerald-200 rounded-lg p-4" }, [
                _cache[8] || (_cache[8] = _createElementVNode("p", { class: "font-semibold text-emerald-900 mb-1" }, "Production (live)", -1)),
                _createElementVNode("code", { class: "text-xs break-all text-emerald-800" }, _toDisplayString(LIVE_BASE))
              ])
            ]),
            _cache[10] || (_cache[10] = _createElementVNode("div", { class: "bg-gray-50 border border-gray-200 rounded-lg p-4 text-sm text-gray-700" }, [
              _createElementVNode("p", { class: "font-semibold text-gray-900 mb-1" }, "Idempotence"),
              _createElementVNode("p", null, [
                _createTextVNode(" Les créations (livraison, paiement) exigent un en-tête "),
                _createElementVNode("code", { class: "bg-white px-1.5 py-0.5 rounded text-xs border" }, "Idempotency-Key"),
                _createTextVNode(" unique. Rejouer la même clé avec le même corps renvoie la réponse d'origine au lieu de créer un doublon : vous pouvez donc réessayer sans risque après un timeout réseau. ")
              ])
            ], -1))
          ]))
        : (tab.value === 'webhooks')
          ? (_openBlock(), _createElementBlock("section", _hoisted_10, [
              _cache[12] || (_cache[12] = _createStaticVNode("<h3 class=\"text-lg font-bold text-gray-900\">Webhooks &amp; vérification de signature</h3><p class=\"text-sm text-gray-600\"> Chaque événement est envoyé en POST JSON avec l&#39;en-tête <code class=\"bg-gray-100 px-1.5 py-0.5 rounded text-xs\">X-Youdego-Signature: t=&lt;horodatage&gt;,v1=&lt;hmac&gt;</code>. Le HMAC est calculé en SHA-256 sur <code class=\"bg-gray-100 px-1.5 py-0.5 rounded text-xs\">`${t}.${corpsBrut}`</code> avec le secret de l&#39;endpoint. Vérifiez-le toujours avant de traiter l&#39;événement. </p><pre class=\"bg-gray-900 text-gray-100 rounded-lg p-4 text-xs overflow-x-auto\">// Node.js (Express)\nconst crypto = require(&#39;crypto&#39;)\n\napp.post(&#39;/webhooks/youdego&#39;,\n  express.raw({ type: &#39;application/json&#39; }),\n  (req, res) =&gt; {\n    const header = req.headers[&#39;x-youdego-signature&#39;] || &#39;&#39;\n    const parts = Object.fromEntries(header.split(&#39;,&#39;).map(p =&gt; p.split(&#39;=&#39;)))\n\n    const expected = crypto\n      .createHmac(&#39;sha256&#39;, process.env.YOUDEGO_WEBHOOK_SECRET)\n      .update(`${parts.t}.${req.body}`)\n      .digest(&#39;hex&#39;)\n\n    if (!crypto.timingSafeEqual(Buffer.from(expected), Buffer.from(parts.v1))) {\n      return res.status(400).send(&#39;signature invalide&#39;)\n    }\n\n    const event = JSON.parse(req.body)\n    // event.id sert d&#39;identifiant d&#39;idempotence côté réception\n    console.log(event.type, event.data)\n\n    res.sendStatus(200) // répondez 2xx rapidement\n  })</pre>", 3)),
              _createElementVNode("div", null, [
                _cache[11] || (_cache[11] = _createElementVNode("h4", { class: "font-semibold text-gray-900 text-sm mb-3" }, "Catalogue des événements", -1)),
                _createElementVNode("div", _hoisted_11, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(EVENT_TYPES), (evt) => {
                    return (_openBlock(), _createElementBlock("div", {
                      key: evt,
                      class: "p-3"
                    }, [
                      _createElementVNode("code", _hoisted_12, _toDisplayString(evt), 1),
                      _createElementVNode("p", _hoisted_13, _toDisplayString(_unref(EVENT_DESCRIPTIONS)[evt]), 1)
                    ]))
                  }), 128))
                ])
              ])
            ]))
          : (tab.value === 'sandbox')
            ? (_openBlock(), _createElementBlock("section", _hoisted_14, [
                _cache[16] || (_cache[16] = _createElementVNode("h3", { class: "text-lg font-bold text-gray-900" }, "Bac à sable", -1)),
                _cache[17] || (_cache[17] = _createElementVNode("p", { class: "text-sm text-gray-600" }, " Avec une clé de test, aucun vrai livreur n'est sollicité : un simulateur fait avancer automatiquement vos livraisons (acceptation en ~10 s, puis ramassage et livraison), et règle vos paiements en ~15 s. Vos webhooks sont appelés exactement comme en production. ", -1)),
                _createElementVNode("div", null, [
                  _cache[13] || (_cache[13] = _createElementVNode("h4", { class: "font-semibold text-gray-900 text-sm mb-3" }, "Provoquer un cas d'échec", -1)),
                  _cache[14] || (_cache[14] = _createElementVNode("p", { class: "text-sm text-gray-600 mb-3" }, [
                    _createTextVNode(" Ajoutez un objet "),
                    _createElementVNode("code", { class: "bg-gray-100 px-1.5 py-0.5 rounded text-xs" }, "sandbox"),
                    _createTextVNode(" à la création : ")
                  ], -1)),
                  _cache[15] || (_cache[15] = _createElementVNode("pre", { class: "bg-gray-900 text-gray-100 rounded-lg p-4 text-xs overflow-x-auto" }, "{ \"…\": \"…\", \"sandbox\": { \"scenario\": \"request_failed\" } }", -1)),
                  _createElementVNode("div", _hoisted_15, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(SANDBOX_SCENARIOS), (s) => {
                      return (_openBlock(), _createElementBlock("div", {
                        key: s.scenario,
                        class: "p-3"
                      }, [
                        _createElementVNode("code", _hoisted_16, _toDisplayString(s.scenario), 1),
                        _createElementVNode("p", _hoisted_17, _toDisplayString(s.effect), 1)
                      ]))
                    }), 128))
                  ])
                ]),
                _cache[18] || (_cache[18] = _createElementVNode("div", { class: "bg-gray-50 border border-gray-200 rounded-lg p-4 text-sm text-gray-700" }, [
                  _createElementVNode("p", { class: "font-semibold text-gray-900 mb-1" }, "Paiement en échec"),
                  _createElementVNode("p", null, [
                    _createTextVNode("Un montant se terminant par "),
                    _createElementVNode("strong", null, "99"),
                    _createTextVNode(" (ex : 1099) échoue volontairement.")
                  ])
                ], -1))
              ]))
            : (_openBlock(), _createElementBlock(_Fragment, { key: 3 }, [
                _createElementVNode("section", _hoisted_18, [
                  _createElementVNode("div", _hoisted_19, [
                    _createElementVNode("span", {
                      class: _normalizeClass([
                'px-2.5 py-1 rounded text-xs font-bold',
                selected.value.method === 'GET' ? 'bg-blue-100 text-blue-800' : 'bg-emerald-100 text-emerald-800'
              ])
                    }, _toDisplayString(selected.value.method), 3),
                    _createElementVNode("code", _hoisted_20, _toDisplayString(selected.value.path), 1),
                    (selected.value.idempotent)
                      ? (_openBlock(), _createElementBlock("span", _hoisted_21, " Idempotency-Key requis "))
                      : _createCommentVNode("", true)
                  ]),
                  _createElementVNode("h3", _hoisted_22, _toDisplayString(selected.value.title), 1),
                  _createElementVNode("p", _hoisted_23, _toDisplayString(selected.value.description), 1),
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(fieldGroups.value, (group) => {
                    return (_openBlock(), _createElementBlock("div", {
                      key: group.title,
                      class: "mt-5"
                    }, [
                      _createElementVNode("h4", _hoisted_24, _toDisplayString(group.title), 1),
                      _createElementVNode("div", _hoisted_25, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(group.fields, (f) => {
                          return (_openBlock(), _createElementBlock("div", {
                            key: f.name,
                            class: "p-3"
                          }, [
                            _createElementVNode("div", _hoisted_26, [
                              _createElementVNode("code", _hoisted_27, _toDisplayString(f.name), 1),
                              _createElementVNode("span", _hoisted_28, _toDisplayString(f.type), 1),
                              _createElementVNode("span", {
                                class: _normalizeClass([
                      'text-[11px] px-1.5 py-0.5 rounded font-medium',
                      f.required ? 'bg-red-50 text-[#8C0004]' : 'bg-gray-100 text-gray-500'
                    ])
                              }, _toDisplayString(f.required ? 'requis' : 'optionnel'), 3),
                              (f.default)
                                ? (_openBlock(), _createElementBlock("span", _hoisted_29, [
                                    _cache[19] || (_cache[19] = _createTextVNode(" défaut : ", -1)),
                                    _createElementVNode("code", _hoisted_30, _toDisplayString(f.default), 1)
                                  ]))
                                : _createCommentVNode("", true)
                            ]),
                            _createElementVNode("p", _hoisted_31, _toDisplayString(f.description), 1),
                            (f.values)
                              ? (_openBlock(), _createElementBlock("div", _hoisted_32, [
                                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(f.values, (v) => {
                                    return (_openBlock(), _createElementBlock("div", {
                                      key: v.value,
                                      class: "flex gap-2 items-baseline"
                                    }, [
                                      _createElementVNode("code", _hoisted_33, _toDisplayString(v.value), 1),
                                      _createElementVNode("span", _hoisted_34, _toDisplayString(v.description), 1)
                                    ]))
                                  }), 128))
                                ]))
                              : _createCommentVNode("", true)
                          ]))
                        }), 128))
                      ])
                    ]))
                  }), 128))
                ]),
                _createElementVNode("section", _hoisted_35, [
                  _cache[20] || (_cache[20] = _createElementVNode("h3", { class: "font-semibold text-gray-900 mb-1" }, "Réponses possibles", -1)),
                  _cache[21] || (_cache[21] = _createElementVNode("p", { class: "text-xs text-gray-500 mb-4" }, [
                    _createTextVNode(" Chaque erreur porte un "),
                    _createElementVNode("code", { class: "bg-gray-100 px-1 py-0.5 rounded" }, "code"),
                    _createTextVNode(" stable : appuyez-vous dessus plutôt que sur le message, qui peut évoluer. ")
                  ], -1)),
                  _createElementVNode("div", _hoisted_36, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(selected.value.responses, (r, i) => {
                      return (_openBlock(), _createElementBlock("div", {
                        key: `${r.status}-${r.code || i}`
                      }, [
                        _createElementVNode("button", {
                          onClick: ($event: any) => (toggleResponse(i)),
                          class: "w-full flex items-center gap-3 p-3 text-left hover:bg-gray-50 transition-colors"
                        }, [
                          _createElementVNode("span", {
                            class: _normalizeClass(['px-2 py-0.5 rounded text-xs font-bold flex-shrink-0 w-11 text-center', statusClass(r.status)])
                          }, _toDisplayString(r.status), 3),
                          _createElementVNode("span", _hoisted_38, _toDisplayString(r.label), 1),
                          (r.code)
                            ? (_openBlock(), _createElementBlock("code", _hoisted_39, _toDisplayString(r.code), 1))
                            : _createCommentVNode("", true),
                          _createVNode(_unref(Icon), {
                            icon: openResponses.value[i] ? 'solar:alt-arrow-up-linear' : 'solar:alt-arrow-down-linear',
                            class: "w-4 h-4 text-gray-400 ml-auto flex-shrink-0"
                          }, null, 8, ["icon"])
                        ], 8, _hoisted_37),
                        (openResponses.value[i])
                          ? (_openBlock(), _createElementBlock("div", _hoisted_40, [
                              _createElementVNode("p", _hoisted_41, _toDisplayString(r.description), 1),
                              _createElementVNode("pre", _hoisted_42, _toDisplayString(r.example), 1)
                            ]))
                          : _createCommentVNode("", true)
                      ]))
                    }), 128))
                  ])
                ]),
                _createElementVNode("section", _hoisted_43, [
                  _createElementVNode("div", _hoisted_44, [
                    _createElementVNode("div", null, [
                      _cache[23] || (_cache[23] = _createElementVNode("h3", { class: "font-semibold text-gray-900" }, "Essayer", -1)),
                      _createElementVNode("p", _hoisted_45, [
                        _cache[22] || (_cache[22] = _createTextVNode(" Requête envoyée à ", -1)),
                        _createElementVNode("code", _hoisted_46, _toDisplayString(baseUrl.value), 1)
                      ])
                    ]),
                    (_unref(modeStore).isLive)
                      ? (_openBlock(), _createElementBlock("span", _hoisted_47, " Mode live — requêtes réelles "))
                      : _createCommentVNode("", true)
                  ]),
                  _createElementVNode("div", _hoisted_48, [
                    _createElementVNode("div", null, [
                      _cache[27] || (_cache[27] = _createElementVNode("label", { class: "block text-sm font-medium text-gray-700 mb-2" }, "Clé API", -1)),
                      _withDirectives(_createElementVNode("input", {
                        "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((apiKey).value = $event)),
                        type: "password",
                        placeholder: _unref(modeStore).isTest ? 'yk_test_…' : 'yk_live_…',
                        class: "w-full rounded-lg border border-gray-300 px-3 py-2 text-sm font-mono focus:outline-none focus:ring-2 focus:ring-[#8C0004]"
                      }, null, 8, _hoisted_49), [
                        [_vModelText, apiKey.value]
                      ]),
                      _createElementVNode("p", _hoisted_50, [
                        _cache[25] || (_cache[25] = _createTextVNode(" Collez une clé créée dans ", -1)),
                        _createVNode(_component_router_link, {
                          to: "/api-keys",
                          class: "text-[#8C0004] hover:underline"
                        }, {
                          default: _withCtx(() => [...(_cache[24] || (_cache[24] = [
                            _createTextVNode("Clés API", -1)
                          ]))]),
                          _: 1
                        }),
                        _cache[26] || (_cache[26] = _createTextVNode(". Elle reste dans votre navigateur, le temps de la session. ", -1))
                      ])
                    ]),
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(selected.value.pathParams || [], (p) => {
                      return (_openBlock(), _createElementBlock("div", {
                        key: p.name
                      }, [
                        _createElementVNode("label", _hoisted_51, [
                          _createTextVNode(_toDisplayString(p.name) + " ", 1),
                          _cache[28] || (_cache[28] = _createElementVNode("span", { class: "text-red-600" }, "*", -1))
                        ]),
                        _withDirectives(_createElementVNode("input", {
                          "onUpdate:modelValue": ($event: any) => ((pathValues.value[p.name]) = $event),
                          class: "w-full rounded-lg border border-gray-300 px-3 py-2 text-sm font-mono focus:outline-none focus:ring-2 focus:ring-[#8C0004]"
                        }, null, 8, _hoisted_52), [
                          [_vModelText, pathValues.value[p.name]]
                        ]),
                        _createElementVNode("p", _hoisted_53, _toDisplayString(p.description), 1)
                      ]))
                    }), 128)),
                    (selected.value.sampleBody)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_54, [
                          _cache[29] || (_cache[29] = _createElementVNode("label", { class: "block text-sm font-medium text-gray-700 mb-2" }, "Corps de la requête", -1)),
                          _withDirectives(_createElementVNode("textarea", {
                            "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((body).value = $event)),
                            rows: "12",
                            class: "w-full rounded-lg border border-gray-300 px-3 py-2 text-xs font-mono focus:outline-none focus:ring-2 focus:ring-[#8C0004]"
                          }, null, 512), [
                            [_vModelText, body.value]
                          ])
                        ]))
                      : _createCommentVNode("", true),
                    _createElementVNode("button", {
                      onClick: send,
                      disabled: !apiKey.value || sending.value,
                      class: "px-5 py-2.5 bg-[#8C0004] text-white rounded-lg text-sm font-medium hover:bg-red-900 disabled:opacity-50 flex items-center gap-2"
                    }, [
                      (sending.value)
                        ? (_openBlock(), _createBlock(_unref(Icon), {
                            key: 0,
                            icon: "svg-spinners:ring-resize",
                            class: "w-4 h-4"
                          }))
                        : _createCommentVNode("", true),
                      _createTextVNode(" " + _toDisplayString(sending.value ? 'Envoi...' : 'Envoyer la requête'), 1)
                    ], 8, _hoisted_55)
                  ]),
                  (response.value)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_56, [
                        _createElementVNode("div", _hoisted_57, [
                          _cache[30] || (_cache[30] = _createElementVNode("span", { class: "text-sm font-medium text-gray-700" }, "Réponse", -1)),
                          _createElementVNode("span", {
                            class: _normalizeClass([
                  'px-2 py-0.5 rounded text-xs font-bold',
                  response.value.ok ? 'bg-emerald-100 text-emerald-800' : 'bg-red-100 text-red-800'
                ])
                          }, " HTTP " + _toDisplayString(response.value.status), 3)
                        ]),
                        _createElementVNode("pre", _hoisted_58, _toDisplayString(response.value.body), 1)
                      ]))
                    : (_openBlock(), _createElementBlock("div", _hoisted_59, [
                        _createElementVNode("p", _hoisted_60, " Exemple de réponse — " + _toDisplayString(successResponse.value?.label), 1),
                        _createElementVNode("pre", _hoisted_61, _toDisplayString(successResponse.value?.example), 1)
                      ]))
                ]),
                _createElementVNode("section", _hoisted_62, [
                  _cache[31] || (_cache[31] = _createElementVNode("h3", { class: "font-semibold text-gray-900 mb-3" }, "Équivalent curl", -1)),
                  _createElementVNode("pre", _hoisted_63, _toDisplayString(curlSnippet.value), 1)
                ])
              ], 64))
    ])
  ]))
}
}

})